// extracted by mini-css-extract-plugin
module.exports =  {"float-navigation":"ux8Wm5CswzpCBK9mViwz5"};